import { SELLER_PRODUCT_STATUS } from '@/constants'
import { addRouteNameToSellerProduct } from '@/helpers/sellerProduct/addRouteNameToSellerProduct'
import { shuffle } from 'lodash'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    boughtTogether: [],
    similarProducts: [],
    popularInCategory: [],
    cartInputValue: 0,
  },
  actions: {
    getSuggestedGoods: async ({ commit }, product) => {
      const getProductsOnSale = async () => {
        const response = await Vue.$http
          .get('/profile_product/products/', {
            params: {
              status__in: [SELLER_PRODUCT_STATUS.publish, SELLER_PRODUCT_STATUS.not_publish].join(','),
              discount__gt: 0,
            },
          })
          .catch(e => {
            console.error(e)
            return []
          })

        return response.results.filter(p => p.id !== product.id)
      }

      const getSimilarProducts = async () => {
        const response = await Vue.$http
          .get('/profile_product/products/', {
            params: {
              status__in: [SELLER_PRODUCT_STATUS.publish, SELLER_PRODUCT_STATUS.not_publish].join(','),
              product__in: `${product.product.id}`,
            },
          })
          .catch(e => {
            console.error(e)
            return []
          })

        return response.results.filter(p => p.id !== product.id)
      }

      const getProductsInGroup = async () => {
        const response = await Vue.$http
          .get('/profile_product/products/', {
            params: {
              status__in: [SELLER_PRODUCT_STATUS.publish, SELLER_PRODUCT_STATUS.not_publish].join(','),
              product__group__in: `${product.group.id}`,
            },
          })
          .catch(e => {
            console.error(e)
            return []
          })

        return response.results.filter(p => p.id !== product.id)
      }

      let [productsOnSale, similarProducts, productsInGroup] = await Promise.all([
        getProductsOnSale(),
        getSimilarProducts(),
        getProductsInGroup(),
      ])

      let boughtTogether = shuffle(productsOnSale).slice(0, 3)

      let similar = similarProducts.filter(p => !boughtTogether.some(item => item.id === p.id))
      // Если товаров по наименованию "Апельсин" меньше десктопного количества
      // для отображения (4) – вмешиваем товары из категории
      if (similar.length < 4) {
        similar = [
          ...similar,
          ...productsInGroup.filter(p => !similar.some(item => item.id === p.id)).splice(0, 4 - similar.length),
        ]
      }

      let inCategory = productsInGroup.filter(
        p => !boughtTogether.some(item => item.id === p.id) && !similar.some(item => item.id === p.id),
      )

      commit('SET_BOUGHT_TOGETHER', boughtTogether.map(addRouteNameToSellerProduct))
      commit('SET_SIMILAR_PRODUCTS', similar.map(addRouteNameToSellerProduct))
      commit('SET_POPULAR_IN_CATEGORY', inCategory.map(addRouteNameToSellerProduct))
    },
    setCartInputValue({ commit }, val) {
      commit('UPDATE_CART_INPUT_VALUE', val)
    },
    resetState({ commit }) {
      commit('RESET')
    },
  },
  mutations: {
    SET_BOUGHT_TOGETHER(state, products) {
      state.boughtTogether = products
    },
    SET_SIMILAR_PRODUCTS(state, products) {
      state.similarProducts = products
    },
    SET_POPULAR_IN_CATEGORY(state, products) {
      state.popularInCategory = products
    },
    UPDATE_CART_INPUT_VALUE(state, val) {
      state.cartInputValue = val
    },
    RESET(state) {
      state.boughtTogether = []
      state.similarProducts = []
      state.popularInCategory = []
      state.cartInputValue = 0
    },
  },
}
